import { TinyEmitter } from 'tiny-emitter'

const emitter = new TinyEmitter()

const $on = emitter.on
const $once = emitter.once
const $off = emitter.off
const $emit = emitter.emit

const eventBus = { $on, $once, $off, $emit }
export { eventBus }
